import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    restricted: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            restricted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "RestrictedFolderIcon.restricted?c=1uwijwqg1t0rx", defaultMessage: "Restricted" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
